import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import VerticalLabelList from '../../label/VerticalLabelList';
import FieldSet from '../../fieldset/FieldSet';

const IPBSDetailedPayableView = ({ selectedPayable, }) => {
  const renderPayableData = () => {
    const formattedPayable = Object.keys(selectedPayable)
      .filter(key => !!selectedPayable[key])
      .reduce((obj, key) => {
        let value = selectedPayable[key];
        if (typeof value === 'object') {
          value = JSON.stringify(value);
        } else {
          value = String(value);
        }
         
        obj[_.startCase(key)] = value;
        return obj;
      }, {});
    const items = VerticalLabelList.toList(formattedPayable);

    return (
      <FieldSet title="Payable Data" style={{ maxHeight: '400px', }}>
        <VerticalLabelList items={items} />
      </FieldSet>
    );
  };

  return (
    <>
      {renderPayableData()}
    </>
  );
};

IPBSDetailedPayableView.propTypes = {
  selectedPayable: PropTypes.instanceOf(Object).isRequired,
};

export default IPBSDetailedPayableView;
